import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global Auth Interceptor: Automatically attaches JWT Bearer token to all outgoing API requests
const originalFetch = window.fetch;
window.fetch = async function (url, options = {}) {
  const token = localStorage.getItem('dms_auth_token') || sessionStorage.getItem('dms_auth_token');
  const opts = { ...options };

  if (token) {
    const existingHeaders = opts.headers ? { ...opts.headers } : {};
    if (!existingHeaders['Authorization'] && !existingHeaders['authorization']) {
      existingHeaders['Authorization'] = `Bearer ${token}`;
    }
    opts.headers = existingHeaders;
  }

  const response = await originalFetch(url, opts);

  if (response.status === 401 && typeof url === 'string' && !url.includes('/api/auth/')) {
    console.warn('[Auth Interceptor] Received 401 Unauthorized for:', url);
  }

  return response;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
